import { api } from "./api";
import {
  CurrentUserResponse,
  UpdateProfileRequest,
  UpdateProfileResponse,
  ChangePasswordRequest,
  ChangePasswordResponse,
} from "Models/auth";

export const userApi = api.injectEndpoints({
  endpoints: (build) => ({
    getMe: build.query<CurrentUserResponse, void>({
      query: () => ({
        url: "auth/me",
        method: "GET",
      }),
    }),
    updateProfile: build.mutation<UpdateProfileResponse, UpdateProfileRequest>({
      query: (params) => ({
        url: "auth/me",
        method: "PATCH",
        body: params,
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(userApi.util.updateQueryData("getMe", undefined, () => data.user));
        } catch {}
      },
    }),
    changePassword: build.mutation<ChangePasswordResponse, ChangePasswordRequest>({
      query: (params) => ({
        url: "auth/change-password",
        method: "POST",
        body: params,
      }),
    }),
  }),
});

export const {
  useGetMeQuery,
  useLazyGetMeQuery,
  useUpdateProfileMutation,
  useChangePasswordMutation,
} = userApi;
